export async function exportWorkbook(title, rows, metadata = {}) {
  const ExcelJS = await import('exceljs');
  const Workbook = ExcelJS.Workbook || ExcelJS.default.Workbook;
  const book = new Workbook();
  book.creator = 'Control de Estanques';
  book.created = new Date();
  const sheet = book.addWorksheet('Datos');
  rows.forEach(row => sheet.addRow(row.map(value => value == null ? '' : value)));
  sheet.getRow(1).font = { bold: true };
  sheet.columns.forEach(column => { column.width = 25; });
  sheet.views = [{ state: 'frozen', ySplit: 1 }];
  const info = book.addWorksheet('Información');
  Object.entries({ Informe: title, Generado: new Date().toISOString(), ZonaHoraria: Intl.DateTimeFormat().resolvedOptions().timeZone, ...metadata }).forEach(pair => info.addRow(pair));
  info.columns = [{width:28},{width:100}];
  const data = await book.xlsx.writeBuffer();
  const url = URL.createObjectURL(new Blob([data], {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
  const a=document.createElement('a');a.href=url;a.download=`${title}-${new Date().toISOString().slice(0,10)}.xlsx`;a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export async function exportTableWorkbook(title, thead, htmlRows, metadata = {}) {
  const doc=new DOMParser().parseFromString(`<table><thead>${thead}</thead><tbody>${htmlRows}</tbody></table>`,'text/html');
  const rows=[...doc.querySelectorAll('tr')].map(row => [...row.querySelectorAll('th,td')].map(cell => cell.textContent.trim()));
  return exportWorkbook(title,rows,{Tipo:'Inventario actual; no corresponde a lecturas de sensores', ...metadata});
}
